module.exports = __webpack_public_path__ + "img/tams.3b23cce5.png";